import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-images';

class Gallery extends Component {
    constructor() {
        super();

        this.state = {
            lightboxIsOpen: false,
            currentImage: 0
        };

        this.closeLightbox = this.closeLightbox.bind(this);
        this.gotoNext = this.gotoNext.bind(this);
        this.gotoPrevious = this.gotoPrevious.bind(this);
        this.gotoImage = this.gotoImage.bind(this);
        this.handleClickImage = this.handleClickImage.bind(this);
        this.openLightbox = this.openLightbox.bind(this);
    }
    openLightbox(event) {
        event.preventDefault();
        this.setState({
            currentImage: +event.currentTarget.dataset.index,
            lightboxIsOpen: true
        });
    }
    closeLightbox() {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false
        });
    }
    gotoPrevious() {
        this.setState({
            currentImage: this.state.currentImage - 1
        });
    }
    gotoNext() {
        this.setState({
            currentImage: this.state.currentImage + 1
        });
    }
    gotoImage(index) {
        this.setState({
            currentImage: index
        });
    }
    handleClickImage() {
        if (this.state.currentImage === this.props.images.length - 1) return;
        this.gotoNext();
    }
    renderGallery() {
        const {rawImages} = this.props;
        let imageIndex = 0;
        const mobileGallery = [];
        const gallery = rawImages.map((obj) => {
            const myArray = [];
            obj.images.map((image) => {
                mobileGallery.push((
                    <li className="mobile-screenshot" key={imageIndex}>
                        <div>
                            <a
                                href={image.screenshot}
                                data-index={imageIndex}
                                onClick={(e) => {this.openLightbox(e);}} >
                                <img src={image.screenshot} alt="thumbnail" />
                            </a>
                        </div>
                    </li>
                ));
                const ele = (
                    <div key={imageIndex}>
                        <a
                            href={image.screenshot}
                            data-index={imageIndex}
                            onClick={(e) => { this.openLightbox(e); }}>
                            <img src={image.thumbnail} alt="thumbnail" />
                        </a>
                    </div>
                );
                imageIndex++;
                myArray.push(ele);
                return myArray;
            });

            return (
                <li className="laptop-screenshot" key={imageIndex}>
                    {myArray}
                </li>
            );
        });

        return (
            <div>
                {gallery}
                {mobileGallery}
            </div>
        );
    }
    render() {
        return (
            <ul className="screenShots col l12">
                {this.renderGallery()}
                <Lightbox
                    currentImage={this.state.currentImage}
                    images={this.props.images}
                    isOpen={this.state.lightboxIsOpen}
                    onClickImage={this.handleClickImage}
                    onClickNext={this.gotoNext}
                    onClickPrev={this.gotoPrevious}
                    onClickThumbnail={this.gotoImage}
                    onClose={this.closeLightbox}
                    showThumbnails={this.props.showThumbnails}
                    theme={this.props.theme} />
            </ul>
        );
    }
}

Gallery.propTypes = {
    images: PropTypes.array,
    showThumbnails: PropTypes.bool,
    theme: PropTypes.object,
    rawImages: PropTypes.array
};

export default Gallery;

